import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Form, Layout, notification, Row, Space, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { LoadingOutlined } from '@ant-design/icons';
import { useItemsContext } from '@/@presentation/contexts/schedulesContext';
import { Notification } from '@presentation/components/common';
import { ModalConfirmationNf } from './components/ModalConfirmationNf';
import { Receiver } from '../home/receiver';
import invoice from '@/@core/modules/invoice/infra/container.registry';
import { ModalConfirmationPayment } from './components/ModalConfirmationPayment';
import ModalError from '@/@presentation/modules/procedure/pages/form/components/modal';
import { Button } from '@/@presentation/components/form';
import customer from '@/@core/modules/customer/infra/container.registry';
import { CreateCustomerApi } from '@/services/customerUpdateApi';
import { useSelectedMenuContext } from '@/@presentation/contexts/selectedMenu';
import tax from '@/@core/modules/tax/infra/container.registry';
import { useBusinessPartner } from '@/@presentation/hooks/useBusinessPartner';
import { normalizeCnpj, isCnpjLength } from '@/@core/utils/cnpj.utils';
// import { InvoiceInterface } from '@/@core/modules/invoice/domain/invoice.entities';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface InvoiceInterface {
    schedule_id: number
    patient: string
    email: string
    cpf: string
    date: string
    value: string
    text?: string
    hospital: string
    payment_billing_id?: number
    schedule_surgery_id?: number
    customer_id: number
    method_code?: string
    installments_number?: number
    patient_is_foreign: boolean
    customer_is_foreign: boolean
    customer_nationality: string
}

export interface UpdateCustomerInterface {
    id?: number,
    personId?: number,
    scheduleId: number[],
    name: string
    email: string
    registry_code: string
    code: string
    rne?: string
    nationality?: string
    address: {
        id?: number
        street: string
        number: string
        additional_details: string
        zipcode: string
        neighborhood: string
        city: string
        state: string
    }
}
const NfProcess = () => {
    const { setSelectedMenu } = useSelectedMenuContext();

    const navigate = useNavigate()

    const { items, setItems } = useItemsContext()
    const [loading, setLoading] = React.useState(false)
    const [defineValues, setDefineValues] = useState(false)
    const [totalValue, setTotalValue] = useState<number>(0)
    const [companyValue, setCompanyValue] = useState<number>(0)
    const [defaultInfo, setDefaultInfo] = useState('')
    const [doc, setDoc] = useState('')
    const [taxError, setTaxError] = useState(false)

    const [nfError, setNfError] = useState({ open: false, message: '' })

    const [receiverVisible, setReceiverVisible] = useState(false)

    const [error, setError] = useState(false)

    const [showConfirmation, setShowConfirmation] = useState(false)
    const [showConfirmationPayment, setShowConfirmationPayment] = useState(false)
    const { resetBusinessPartnerError } = useBusinessPartner();
    const [bpValidationResult, setBpValidationResult] = useState<boolean>(true); // ✅ Armazena resultado BP do Receiver

    const [itemBase, setItemBase] = useState<any>()

    const updateItemsValues = () => {

        items.forEach((item) => {
            item.paymentCustomer.city = itemBase?.paymentCustomer?.city
            item.paymentCustomer.country = itemBase?.paymentCustomer?.country
            item.paymentCustomer.email = itemBase?.paymentCustomer?.email
            item.paymentCustomer.id = itemBase?.paymentCustomer?.id
            item.paymentCustomer.name = itemBase?.paymentCustomer?.name
            item.paymentCustomer.neighborhood = itemBase?.paymentCustomer?.neighborhood
            item.paymentCustomer.number = itemBase?.paymentCustomer?.number
            item.paymentCustomer.registry_code = itemBase?.paymentCustomer?.registry_code
            item.paymentCustomer.state = itemBase?.paymentCustomer?.state
            item.paymentCustomer.street = itemBase?.paymentCustomer?.street
            item.paymentCustomer.zipcode = itemBase?.paymentCustomer?.zipcode
            item.paymentCustomer.complement = itemBase?.paymentCustomer?.complement
            item.paymentCustomer.rne = itemBase?.paymentCustomer?.rne
            item.paymentCustomer.nationality = itemBase?.paymentCustomer?.nationality
            item.paymentCustomer.address = itemBase?.paymentCustomer?.address
        })
        setItems([...items]) // Criar nova referência para forçar re-render
    }

    useEffect(() => {
        if (items.length > 0) {
            setItemBase(items[0])
            if (!receiverVisible) {
                const currentDoc = normalizeCnpj(items[0]?.paymentCustomer?.registry_code ?? '');
                const isCNPJ = isCnpjLength(currentDoc);
                if (!isCNPJ || bpValidationResult) {
                    handleDefineValues()
                }
            }
        }
    }, [items])

    // Atualizar todos os items quando itemBase for modificado
    useEffect(() => {
        if (itemBase && items.length > 0) {
            updateItemsValues()
        }
    }, [itemBase])

    // Inicializar doc quando itemBase for definido
    useEffect(() => {
        if (itemBase?.paymentCustomer?.registry_code) {
            setDoc(itemBase.paymentCustomer.registry_code)
        }
    }, [itemBase])

    const handleDefineValues = async () => {
        if(loading){
            return;
        }
        try {
        setLoading(true)
        setDefineValues(true);

        const txtHeader = 'Serviço Médico de Anestesia Prestados ao paciente:';
        const txtFooter = '[1]Valor aproximado dos tributos conforme Lei nº 12741 de 08.12.2012';

        const groupedByPatient = items.reduce((acc, item) => {
            const { anesthetist, patient, procedureDate, anesthetistCrm, paymentCustomer } = item;

            if (!acc[patient]) {
                acc[patient] = [];
            }
            acc[patient].push({ anesthetist, procedureDate, anesthetistCrm, paymentCustomer });
            return acc;
        }, {} as Record<string, any[]>);

            let formattedData = '';



            // Formata os dados conforme o formato solicitado
            formattedData = Object.entries(groupedByPatient).map(([patient, procedures]) => {
                return (procedures as any[]).map((procedure: any) => {
                    const { procedureDate, anesthetist, anesthetistCrm } = procedure;

                    // Verifica se o paciente é estrangeiro
                    const isPatientForeign = procedure?.paymentCustomer?.nationality?.toUpperCase() !== 'BR' &&
                        procedure?.paymentCustomer?.nationality?.trim() !== '' &&
                        procedure?.paymentCustomer?.nationality !== null;

                    const foreignNote = isPatientForeign ? 'ESTRANGEIRO' : '';

                    const formattedPatient = `${patient.toUpperCase()} - Data: ${procedureDate}`;
                    const formattedAnesthetist = `Anestesista: Dr.: ${anesthetist} - CRM.: ${anesthetistCrm}`;
                    return `${foreignNote}\n${formattedPatient}\n${formattedAnesthetist}`;
                }).join('\n');
            }).join('\n');


            const calculatedTotalValue = items.reduce((acc, item) => {
                if (!item.total) {
                    return acc;
                }

                const totalWithoutCurrency = item.total.replace(/[^\d,]/g, '');
                const totalWithDot = totalWithoutCurrency.replace(',', '.');

                const parsedTotal = parseFloat(totalWithDot);
                return isNaN(parsedTotal) ? acc : acc + parsedTotal;
            }, 0);

        setTotalValue(calculatedTotalValue);

        const formattedTotal = calculatedTotalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        
        // Calcular valor com taxa usando o módulo centralizado
        let calculatedCompanyValue = calculatedTotalValue;
        const formatedDocument = normalizeCnpj(doc ?? '');
        const isCompany = isCnpjLength(formatedDocument);

        if (isCompany && bpValidationResult) {
            try {
                setLoading(true);
                setTaxError(false);
                const taxes = items
                    .filter(item => item.total && item.id)
                    .map((item) => {
                        const totalWithoutCurrency = item.total.replace(/[^\d,]/g, '');
                        const totalWithDot = totalWithoutCurrency.replace(',', '.');
                        const parsedTotal = parseFloat(totalWithDot);
                        return {
                            amount: isNaN(parsedTotal) ? 0 : parsedTotal,
                            scheduleId: item.id
                        };
                    });

                calculatedCompanyValue = await tax.calcTaxNF.execute({ 
                    taxes,
                    document: formatedDocument,
                    count: taxes.length
                });
            } catch (error) {
                setTaxError(true);
                const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido ao calcular impostos';
                Notification.error({
                    message: 'O cadastro está em análise devido à possível retenção de impostos. Por favor, tente novamente após 30 minutos ou aguarde a confirmação de um de nossos especialistas.',
                    duration: 5,
                });
            } finally {
                setLoading(false);
            }
        }
        setCompanyValue(calculatedCompanyValue);
        const formattedCompanyValue = calculatedCompanyValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        
        // Adiciona os valores bruto e líquido se for uma empresa, ou apenas o valor total se for CPF
        const companyText = isCompany 
            ? `\n\n\nValor bruto: ${formattedTotal}\nValor líquido: ${formattedCompanyValue}\n\n`
            : `\n\n\nValor Total: ${formattedTotal}\n\n`;

        const fullText = `${txtHeader}\n\n${formattedData}\n\n${companyText}\n${txtFooter}`;

        setDefaultInfo(fullText);
        } catch (error) {
            setError(true)
        }
        finally {
            setLoading(false)
        }
    }

    async function handleRequestNf() {
        try {
            setLoading(true)
        // Verifica se há items disponíveis
        if (!items || items.length === 0) {
            Notification.error({
                message: 'Nenhum item selecionado para emissão de nota fiscal.',
                duration: 5,
            });
            return;
        }

        // Verifica se o itemBase foi definido
        if (!itemBase) {
            Notification.error({
                message: 'Dados do item não encontrados. Por favor, tente novamente.',
                duration: 5,
            });
            return;
        }

        let customerInfo: any = null;

        if (itemBase?.paymentCustomer?.id && itemBase?.paymentCustomer?.id > 0) {
            customerInfo = await customer.searchById.execute(itemBase?.paymentCustomer?.id);
        } else {
            // Verifica se o registry_code existe antes de fazer a busca
            if (!itemBase?.paymentCustomer?.registry_code) {
                Notification.error({
                    message: 'CPF/CNPJ do tomador não encontrado. Por favor, selecione um tomador válido.',
                    duration: 5,
                });
                return;
            }

            if (itemBase?.paymentCustomer?.nationality?.toUpperCase() === 'BR' || itemBase?.paymentCustomer?.nationality?.toUpperCase() === 'BRASIL' || itemBase?.paymentCustomer?.nationality === null || itemBase?.paymentCustomer?.nationality?.trim() === '') {
                customerInfo = await customer.search.execute(itemBase?.paymentCustomer?.registry_code)
            }

            if (itemBase?.paymentCustomer?.nationality?.toUpperCase() !== 'BR' && itemBase?.paymentCustomer?.nationality?.toUpperCase() !== 'BRASIL' && itemBase?.paymentCustomer?.nationality !== null && itemBase?.paymentCustomer?.nationality?.trim() !== '') {
                if (itemBase?.paymentCustomer?.rne && itemBase?.paymentCustomer?.rne.length > 0) {
                    customerInfo = await customer.searchByRne.execute(itemBase?.paymentCustomer?.rne)
                }

                if ((!itemBase?.paymentCustomer?.rne || itemBase?.paymentCustomer?.rne === "") && itemBase?.rne && itemBase?.rne.length > 0) {
                    customerInfo = await customer.searchByRne.execute(itemBase?.rne)
                }
            }
        }

        const isFieldEmpty = (field: any) => field === null || field === undefined || field === '';

        // mapeamento de rótulos
        const fieldLabels = {
        city: 'Cidade',
        street: 'Rua',
        number: 'Número',
        neighborhood: 'Bairro',
        zipcode: 'CEP',
        name: 'Nome',
        email: 'Email',
        cpf: 'CPF',
        rne: 'RNE',
        nationality: 'Nacionalidade',
        };

        // coleta todos os valores
        const f = {
            city:        customerInfo?.payment_customer?.address?.city,
            street:      customerInfo?.payment_customer?.address?.street,
            number:      customerInfo?.payment_customer?.address?.number,
            neighborhood:customerInfo?.payment_customer?.address?.neighborhood,
            zipcode:     customerInfo?.payment_customer?.address?.zipcode,
            name:        customerInfo?.payment_customer?.person?.name,
            email:       customerInfo?.payment_customer?.person?.email,
            cpf:         customerInfo?.payment_customer?.person?.registry_code || customerInfo?.payment_customer?.person?.cpf,
            rne:         customerInfo?.payment_customer?.person?.rne,
            nationality: customerInfo?.payment_customer?.person?.nationality,
        };

        // define quais campos são sempre necessários
        const mandatory = ['city','street','number','neighborhood','zipcode','name','email'];

        // Validação de campos obrigatórios baseada na nacionalidade
        const nationality = f.nationality;
        const isBrazilianOrEmpty = !nationality || nationality === 'BR' || nationality === 'BRASIL';
        
        if (isBrazilianOrEmpty) {
            // Se for brasileiro ou vazio/null, CPF é obrigatório e nacionalidade é opcional
            mandatory.push('cpf');
        } else {
            // Se for estrangeiro, nacionalidade é obrigatória e CPF é opcional
            mandatory.push('nationality');
        }
        // verifica quais estão faltando
        const missingFields = mandatory
        .filter(key => isFieldEmpty(f[key as keyof typeof f]))
        .map(key => fieldLabels[key as keyof typeof fieldLabels]);

        if (missingFields.length > 0) {
        Notification.error({
            message: `Os seguintes campos obrigatórios estão vazios: ${missingFields.join(', ')}`,
            duration: 5,
        });
        return;
        }

        if (itemBase.paymentCustomer.id === 0) {
            const newCustomer: UpdateCustomerInterface = {
            scheduleId: [itemBase.id],
            personId:   customerInfo.payment_customer.person.id,
            name:       itemBase.paymentCustomer.name,
            email:      itemBase.paymentCustomer.email,
            registry_code: itemBase.paymentCustomer.registry_code,
            code: itemBase.paymentCustomer.registry_code,
            nationality: customerInfo?.payment_customer?.person?.nationality,
            rne:         customerInfo?.payment_customer?.person?.rne,
            address: {
                id:                customerInfo.payment_customer.address.id,
                street:            customerInfo?.payment_customer?.person?.street,
                number:            customerInfo?.payment_customer?.person?.number,
                additional_details: customerInfo?.payment_customer?.person?.complement ?? '',
                zipcode:           customerInfo?.payment_customer?.person?.zipcode,
                neighborhood:      customerInfo?.payment_customer?.person?.neighborhood,
                city:              customerInfo?.payment_customer?.person?.city,
                state:             customerInfo?.payment_customer?.person?.state,
            }
            };

            setDoc(newCustomer.registry_code)
            await CreateCustomerApi(newCustomer);
        }
        const customerName = customerInfo?.payment_customer?.person?.name ?? ''
        const customerEmail = customerInfo?.payment_customer?.person?.email ?? ''
        const customerCpf = itemBase?.paymentCustomer?.registry_code ?? ''
        setDoc(customerCpf)
        const customerStreet = customerInfo?.payment_customer?.address?.street ?? ''
        const customerNumberHome = customerInfo?.payment_customer?.address?.number ?? ''
        const customerCep = customerInfo?.payment_customer?.address?.zipcode ?? ''

        // Validação de nacionalidade removida - já é tratada na validação de campos obrigatórios acima

        // Validação consistente com a lógica de nacionalidade
        const customerNationality = customerInfo?.payment_customer?.person?.nationality;
        const isCustomerBrazilianOrEmpty = !customerNationality || customerNationality === 'BR' || customerNationality === 'BRASIL';
        
        if (customerName?.length === 0 ||
            customerEmail?.length === 0 ||
            (customerCpf?.length === 0 && isCustomerBrazilianOrEmpty) ||
            customerStreet?.length === 0 ||
            customerNumberHome?.length === 0 ||
            customerCep?.length === 0
        ) {
            Notification.error({
                message: 'Por favor confirmar os campos obrigatórios do tomador!',
                duration: 5,
            });

            return
        } else if (defaultInfo?.length === 0) {
            setError(true)
            Notification.error({
                message: 'Por favor verifique as Observações de encerramento!',
                duration: 3,
            });

        } else {
            setError(false)
            setShowConfirmation(true)
        }

        } catch (error) {
            setError(true)
            Notification.error({
                message: 'Erro ao verificar campos obrigatórios. Por favor, tente novamente.',
                duration: 5,
            });
            return;
        }
        finally {
            setLoading(false)
        }
    }

    async function handleConfirmation() {

        try {
            setLoading(true);

            const nfs: InvoiceInterface[] = items.map((item) => ({
                schedule_id: item?.id,
                cpf: normalizeCnpj(item?.paymentCustomer?.registry_code ?? ''),
                date: item?.scheduleDate,
                hospital: item?.unit,
                patient: item?.patient,
                //text: defaultInfo,
                value: item?.total,
                email: item?.paymentCustomer?.email,
                payment_billing_id: item?.paymentBillingId ?? 0,
                schedule_surgery_id: item?.scheduleSurgeryId ?? 0,
                customer_id: item?.paymentCustomer?.id ?? 0,
                patient_is_foreign: item?.patientNationality?.toUpperCase() !== 'BR' && item?.patientNationality?.trim() !== '' && item?.patientNationality !== null,
                customer_is_foreign: item?.paymentCustomer?.nationality?.toUpperCase() !== 'BR' && item?.paymentCustomer?.nationality?.trim() !== '' && item?.paymentCustomer?.nationality !== null,
                customer_nationality: item?.paymentCustomer?.nationality?.toUpperCase() || 'BR',
            }));

            const res = await invoice.create.execute(nfs, defaultInfo, totalValue, companyValue, items?.length) ?? [];
            if (!res) {
                Notification.error({
                    message: 'Erro ao emitir nota fiscal.',
                    duration: 5,
                });
                setLoading(false);
                return;
            }

            if (res?.status === 'nf_async') {
                Notification.success({
                    message: res?.message || 'Solicitação e NF realizada com sucesso!',
                    duration: 5,
                });
                setShowConfirmation(false);
                setSelectedMenu('/finance');
                navigate('/finance');
                return;
            }

            // Coleta todos os erros da resposta
            const allErrors: string[] = [];
            let notaFiscalSuccess = false;
            let notaFiscalMessage = '';

            res.forEach((item: any) => {
                // Verifica Email
                if (item.Email) {
                    const emailStatus = item.Email.status;
                    const emailMessage = item.Email.message;

                    if (String(emailStatus).toLowerCase().includes('erro')) {
                        allErrors.push(emailMessage);
                    }
                }

                // Verifica NotaFiscal
                if (item.NotaFiscal) {
                    const nfStatus = item.NotaFiscal.status;
                    const nfMessage = item.NotaFiscal.message;

                    if (String(nfStatus).toLowerCase().includes('erro')) {
                        allErrors.push(nfMessage);
                    } else if (String(nfStatus).toLowerCase() === 'success') {
                        notaFiscalSuccess = true;
                        notaFiscalMessage = nfMessage;
                    }
                }
            });

            // Verifica se há sucesso na nota fiscal
            const someSuccess = notaFiscalSuccess;

            if (someSuccess) {
                setItems([...items]); // força atualização

                Notification.success({
                    message: notaFiscalMessage || 'Solicitação e NF realizada com sucesso!',
                    duration: 3,
                });

                setShowConfirmation(false);

                // Verifica se precisa mostrar modal de pagamento para todos os tipos de tomador
                const showConfirmationControl = items.some(item => item.statusBilling === 'allpending');

                if (showConfirmationControl) {
                    setShowConfirmationPayment(true);
                } else {
                    setSelectedMenu('/finance');
                    navigate('/finance');
                }
            } else {
                // Se não há sucessos, mostra o primeiro erro encontrado
                if (allErrors.length > 0) {
                    setNfError({
                        open: true,
                        message: allErrors[0] || 'Erro ao emitir nota fiscal'
                    });
                } else {
                    notification.error({
                        message: 'Erro ao solicitar NF, status de retorno não identificado!',
                        duration: 3,
                    });
                }

                setShowConfirmation(false);
            }
        } catch (error) {
            notification.error({
                message: 'Falha ao solicitar NF',
                duration: 3
            });
        } finally {
            setLoading(false);
        }
    }

    async function handleConfirmationPayment() {
        updateItemsValues()
        navigate('/paymentprocess', { 
            state: { 
                id: items[0].id, 
                registry_code: doc,
                paymentCustomer: itemBase?.paymentCustomer,
                isBusinessPartnerValid: bpValidationResult
            } 
        })
    }

    async function handleCancelPayment() {
        setShowConfirmationPayment(false)
        setSelectedMenu('/finance');
        navigate('/finance')
    }

    return (

        <Layout
            data-testid="layout-schedule-view"
            style={{
                height: '80vh',
                backgroundColor: 'white',
            }}
        >

            <ModalError open={nfError.open} title='Erro ao confirmar nota fiscal' onOk={() => setNfError({ open: false, message: '' })} text={nfError.message} />

            <Content className="site-layout-content">
                <Content className="pd-24">
                    <Spin spinning={loading} indicator={antIcon} tip="Carregando..."></Spin>

                    <Row justify="start">
                        <Col xs={24} sm={22} md={22} lg={22} xl={22}>
                            <Space size="small" style={{ display: 'flex' }}></Space>
                        </Col>
                        <Col xs={24} sm={2} md={2} lg={2} xl={2}>
                            <Form.Item></Form.Item>
                        </Col>
                    </Row>

                    <Row style={{ height: 60, marginTop: -50 }}>
                        <p style={{
                            fontSize: 28,
                            fontStyle: 'normal',
                            fontWeight: 700,
                            lineHeight: '4',
                            marginLeft: '5%',
                            // color: '#054B7C'
                            color: '#101010'
                        }}>Nota Fiscal</p>
                    </Row>

                    <Row>
                        <p style={{
                            marginLeft: '5%',
                            marginBottom: 30,
                            fontSize: 18,
                            fontStyle: 'normal',
                            lineHeight: '4',
                            color: '#101010'
                        }}>Emitir nota fiscal</p>
                    </Row>

                    <Row style={{ marginBottom: 10, marginTop: -20 }}>
                        <label style={{ marginLeft: '5%', fontSize: 15, fontWeight: 'bold' }}>Tomador</label>
                    </Row>

                    <Row style={{ marginBottom: 30, marginTop: 10 }}>
                        <label style={{ marginLeft: '5%', fontSize: 15, backgroundColor: '#f5f5f5', paddingTop: 9, paddingBottom: 9, paddingLeft: 15, width: 500, borderRadius: 8 }}>{itemBase?.paymentCustomer?.name.toUpperCase()}</label>
                        <Button
                            nativeProps={{
                                ghost: true,
                                style: {
                                    marginLeft: 10
                                }
                            }}
                            text="Alterar Tomador"
                            onClick={() => {
                                resetBusinessPartnerError(); // Resetar erro ao abrir modal
                                setBpValidationResult(true);
                                setReceiverVisible(true);
                            }}
                        />
                    </Row>

                    <Row style={{ marginBottom: 20 }}>
                        <label style={{ marginLeft: '5%', fontSize: 15, fontWeight: 'bold' }}>Observação de NF</label>
                        <textarea
                            rows={20}
                            style={{
                                width: '90%',
                                marginLeft: '5%',
                                borderRadius: 8,
                                marginTop: 10,
                                marginBottom: 30,
                                padding: 15,
                                fontSize: 16,
                                resize: 'none',
                                borderColor: error ? '#ff0000' : '#054B7C',
                            }}
                            disabled={!defineValues}
                            onChange={(e) => setDefaultInfo(e.target.value)}
                            value={defaultInfo}
                        >
                        </textarea>
                    </Row>

                    <Row style={{
                        bottom: 10,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        paddingBottom: 40,
                        paddingRight: '5%'
                    }}>
                        <Button
                            text='Cancelar'
                            nativeProps={{
                                ghost: true,
                                style: {
                                    marginRight: 10
                                }
                            }}
                            loading={loading}
                            onClick={() => {
                                setSelectedMenu('/finance');
                                navigate('/finance')
                            }}
                        />
                        <Button
                            disabled={loading || error || taxError || !bpValidationResult}
                            loading={loading}
                            text='OK'
                            onClick={() => handleRequestNf()}
                        />
                    </Row>
                </Content>
            </Content>

            <ModalConfirmationNf
                visible={showConfirmation}
                loading={loading}
                children={undefined} title="Confirmar emissão de nota fiscal"
                paymentCustomerNationality={itemBase?.paymentCustomer?.nationality?.toUpperCase() || 'Não informado'}
                paymentCustomerRne={itemBase?.paymentCustomer?.rne || 'Não informado'}
                handleCancel={() => setShowConfirmation(false)}
                handleOk={async () => await handleConfirmation()}
                paymentCustomerName={itemBase?.paymentCustomer?.name.toUpperCase() || 'Não informado'}
            />

            <ModalConfirmationPayment
                visible={showConfirmationPayment}
                children={undefined} title={'Realizar Pagamento'}
                handleCancel={() => handleCancelPayment()}
                handleOk={async () => await handleConfirmationPayment()} messages={[]}/>

            <Receiver
                doc={doc}
                setDoc={setDoc}
                visible={receiverVisible}
                setVisible={setReceiverVisible}
                data={itemBase}
                allData={items}
                setReload={() => {
                    setLoading(true)
                    handleDefineValues()
                    setLoading(false)
                }}
                setItemBase={setItemBase}
                isFromNfProcess={true}
                onBPValidationResult={(isValid) => {
                    setBpValidationResult(isValid);
                    if (isValid) {
                        setTimeout(() => handleDefineValues(), 100);
                    }
                }}
            />
        </Layout>
    );
};

export default NfProcess;
